import React from 'react';
import { Wrapper, Footer, OrganizationTag } from './card-organization-preview.styles';
import { CardOrganizationPreviewProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import { AllInvestmentProducts, AllReceipt } from '@vtbhome/juicyfront/indexIcon';
import { COLORS } from '@shared/config/colors/colors';
import { wordByCount } from '@shared/lib/utils/word-by-count/word-by-count';

export const CardOrganizationPreview: React.FC<CardOrganizationPreviewProps> = ({ organization }) => {
    return (
        <Wrapper>
            <Typography size='subtitle1'>{organization.shortName}</Typography>
            <Typography size='body2_short' color='neutral_50'>
                Реквизиты: ИНН {organization.inn}
                {organization.kpp ? `, КПП ${organization.kpp}` : ''}
            </Typography>
            <Footer>
                <OrganizationTag>
                    <AllInvestmentProducts size='xxs' color={COLORS.neutral_50} />
                    <Typography size='body2_short' color='neutral_50'>
                        {wordByCount({
                            count: organization.countUsers,
                            words: ['сотрудник', 'сотрудника', 'сотрудников'],
                        })}
                    </Typography>
                </OrganizationTag>
                <OrganizationTag>
                    <AllReceipt size='xxs' color={COLORS.neutral_50} />
                    <Typography size='body2_short' color='neutral_50'>
                        {wordByCount({
                            count: organization.countProducts,
                            words: ['продукт', 'продукта', 'продуктов'],
                        })}
                    </Typography>
                </OrganizationTag>
            </Footer>
        </Wrapper>
    );
};
